module.exports = __webpack_public_path__ + "static/media/ic-time-purple.59b9cb9c.svg";